<template>
    <vTransactionConfigDetailComponent :postList="postList" v-if="flag"></vTransactionConfigDetailComponent>
</template>
<script>
import vTransactionConfigDetailComponent from '../../listComponent/basicdata/transactionConfigDetail/transactionConfigDetailComponent.vue';
export default {
    name: 'vTransactionConfigDetail',
    components: {
        vTransactionConfigDetailComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true,
                addBtn: true
            },
            flag: false
        };
    },
    mounted() {
        this.flag = false;
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>